var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_195_654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_195_654",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_195_654",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_195_654",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADAUlEQVR4nO3dT2sTQRgG8NfqxYsirRa/iuLZi3gXLfpN9hPkEBYm77NLUBEvuQhSSKBe1OoXEGE/h4p/Lq5Mm0AQqkl2N3mmeX4w1zIzT2Z2tp28NRMRERERERERERERERERkW3T7/evWILqur4QQrhm58FgMLgN4LW7fwNQu/svAG8BPM6ybMdIZVm2UxTFEwDvAfyc9j2O4VVRFHcsNaPR6CKAEAfyjxaD2TMyAPamQZzZd3fP4xgtFThVL9A+l2W5byTKstyPfVqk7+7+1FIA4Ja7/14wEJpQyiXCmLWiKO4aOwCHywyKIZRyhTCm7dDYTySzB3gqoZSrhxG3rS9xzMYqy7JLS25Xf7cKwM119TeEcAPAp1X7G8fKfFo80WCF1OtcKU1Wxlz7auzc/ajhIOuuV0rTlTHXxsauKIqHLQy07mqltLQyTtpgMHhgibwUHjOGUrYYhru/o39+zAyHw+ttDRwthdJmGPHnxDFaSlrcp+umzxSmvmwUw0QEgj5Q2eSEBIXBMzFBYfBMUFAYi1nHRAWFsZwuJywojNV0MXFBYXC9qIHsRTRJLX+q664PC1uBKJRq68MgCqVSGDwrpVIYPNtXpTB4nimVwuB50FcKgyeUSmHwhFIpjAaCAuERtGXxCHqo8wg69vIIejHkoV+dENEvF4kQhFHrHYUvjHrrQ9GfcInokgMRXQMiootyRHSVlIguWxPR1xGIMFzvDAR9oMA0EYGoLxuR5/ku213bsuW7xHGMloL4tWh3nzB+GkO7K+VNLCVi7KaV2OjC6CiUA2MH4CPLNtX19uXuH4xZrGzg7j8YV0ZHK+U7dTWHWL2TeWV0tFKu2jktz1Rt4jjZcKUkUZ5psi0l/tx9YuwA3E8pjIZFMO9ZCgA8Y96mWtq+Xloqer3eZQAv/rPcjxjfdvM8312gKt7zOEZLzXT7Gs+VGo9H4mN3f8RcGXp0WoTtIL5nzI7x0zGMk9mmFinGT11S9Qyxz6n+IwEREREREREREREREREREbEm/gDz6s1stXQCMAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b57083d2f66ef2de019521f22e969d92.svg";
export { ForwardRef as ReactComponent };